import axios from "lib/axios";

export const updateEnableRpLeaseIdApi = async (organizationId, value) => {
  return await axios.patch(`/super/organizations/${organizationId}/resident_payments/enable_rp_lease_id`, {
    enable_rp_lease_id: value,
  });
};
